import { Tag } from '../types';

export interface HierarchicalTag extends Tag {
  children: HierarchicalTag[];
}

const normalizeHierarchy = (tag: Tag): HierarchicalTag => ({
  name: tag.name,
  children: (tag.children ?? []).map(normalizeHierarchy),
});

export function buildTagHierarchy(tags: Tag[]): HierarchicalTag[] {
  return tags.map(normalizeHierarchy);
}

